import { getInvoicesByDayService } from "../infrastructure/services/getInvoicesByDayService";
import { Payment } from "../domain/payment";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getInvoicesByDay = {
    async execute(paymentDate: string): Promise<Payment[]> {
        return await getInvoicesByDayService.execute(await tokenValidation.execute(), paymentDate);
    },
};
